import React from "react";
import ToggleGroup from "../ToggleGroup";

const STEP_CAKE_BASE_INCHES = { 2: 9, 3: 10 };

// Step cakes: full-cake only, no format/pieces/weight/sheet controls - just
// the step count (each step corresponds to a base tier size, informational).
const StepCakeOptions = ({ layersApply, selectedLayers, onLayersChange, MIN_LAYERS, MAX_LAYERS }) => (
    <>
        {layersApply && (
            <ToggleGroup
                label="Step"
                options={Array.from({ length: MAX_LAYERS - MIN_LAYERS + 1 }, (_, i) => i + MIN_LAYERS)}
                selected={selectedLayers}
                onSelect={onLayersChange}
                formatOption={(v) => `${v} Steps (${STEP_CAKE_BASE_INCHES[v]}" base)`}
            />
        )}
    </>
);

export default StepCakeOptions;
